(() => {
  function setup(scope) {
    scope.querySelectorAll('[data-life-film]').forEach(container => {
      if (container.dataset.ready) return;
      const video = container.querySelector('video');
      const button = container.querySelector('button');
      if (!video || !button) return;
      container.dataset.ready = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const saveData = Boolean(navigator.connection && navigator.connection.saveData);
      let userPaused = false;
      function sync() { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; }
      async function play() {
        if (!video.getAttribute('src')) video.src = (window.innerWidth < 768 && video.dataset.mobileSrc) || video.dataset.desktopSrc;
        video.muted = true;
        try { await video.play(); } catch (_) { sync(); }
      }
      button.hidden = false;
      button.addEventListener('click', () => { if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); } });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('error', () => { video.hidden = true; button.hidden = true; });
      reduced.addEventListener('change', () => { if (reduced.matches) video.pause(); });
      document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); });
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) video.pause();
        else if (!reduced.matches && !saveData && !userPaused && !document.hidden) play();
      }), { threshold: 0.15 });
      observer.observe(container);
      sync();
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
